import { useState, useEffect } from 'react'

export const useResponsive = (query) => {
    const [isMatch, setIsMatch] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches
        }
        return false
    })

    useEffect(() => {
        if (typeof window === 'undefined') return

        const mediaQuery = window.matchMedia(query)
        const handleChange = (e) => {
            setIsMatch(e.matches)
        }
        if (isMatch !== mediaQuery.matches) {
            setIsMatch(mediaQuery.matches)
        }

        mediaQuery.addEventListener('change', handleChange)

        return () => {
            mediaQuery.removeEventListener('change', handleChange)
        }
    }, [query])

    return isMatch
}
